import { ArrowUpRight } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";
import { goToAudit } from "@/lib/scroll";

export const FinalCTA = () => (
  <section className="relative overflow-hidden border-t border-white/5 bg-[#07070C] py-16 sm:py-20">
    <div className="pointer-events-none absolute left-1/2 top-1/2 h-[420px] w-[680px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-purple-600/15 blur-[150px]" />
    <div className="relative mx-auto max-w-6xl px-5 text-center sm:px-8">
      <Reveal>
        <Eyebrow className="text-purple-400">Your Next Customer Is Out There.</Eyebrow>
        <h2 className="mt-6 font-display text-6xl font-extrabold leading-[0.92] tracking-tighter text-white sm:text-7xl lg:text-9xl">
          Let's Go{" "}
          <span className="bg-gradient-to-r from-purple-400 to-purple-600 bg-clip-text text-transparent">
            Get Them.
          </span>
        </h2>
      </Reveal>
      <Reveal delay={0.15}>
        <p className="mx-auto mt-8 max-w-xl text-base text-zinc-400 md:text-lg">
          Find out how Viral Pulse would use Meta and Google advertising to bring
          more opportunities into your business.
        </p>
      </Reveal>
      <Reveal delay={0.25}>
        <button
          type="button"
          data-testid="final-audit-cta"
          onClick={goToAudit}
          className="group mx-auto mt-12 flex w-full items-center justify-center gap-3 rounded-full bg-purple-600 px-10 py-5 font-display text-base font-extrabold uppercase tracking-wide text-white transition-colors duration-300 hover:bg-purple-500 sm:w-auto sm:text-lg"
        >
          Get My Free Lead Audit
          <ArrowUpRight className="h-6 w-6 transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
        </button>
        <p className="mt-5 text-sm text-zinc-500">
          Free strategy review. No obligation.
        </p>
      </Reveal>
    </div>
  </section>
);
